"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var SummaryCard_1 = __importDefault(require("../SummaryCard"));
var queuesSlice_1 = require("../../../Queues/state/queuesSlice");
var overviewSlice_1 = require("../../state/overviewSlice");
function ManualCardGroup() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var queues = (0, react_redux_1.useSelector)(queuesSlice_1.queuesSelector);
    var totalReceivedCount = (0, react_redux_1.useSelector)(overviewSlice_1.getTotalReceivedSelector);
    var remotelyModeratedCount = (0, react_redux_1.useSelector)(overviewSlice_1.remotelyModeratedCountOverviewSelector);
    var resources = {
        inboxName: {
            total: t('DASHBOARD.STATISTICS.TOTAL_RECEIVED'),
            implioModerated: t('DASHBOARD.STATISTICS.IMPLIO_MODERATED'),
            implioModeratedTooltip: t('DASHBOARD.STATISTICS.IMPLIO_MODERATED_TOOLTIP'),
            remotelyModerated: t('DASHBOARD.STATISTICS.REMOTELY_MODERATED'),
            remotelyModeratedTooltip: t('DASHBOARD.STATISTICS.REMOTELY_MODERATED_TOOLTIP'),
        },
        oldestJobAgeTitle: t('DASHBOARD.STATISTICS.OLDEST_ITEM_AGE'),
        nowInManual: t('DASHBOARD.STATISTICS.NOW_IN_MANUAL'),
    };
    var _a = __read(react_1.default.useState(), 2), manualModerationLine = _a[0], setManualModerationLine = _a[1];
    var _b = __read(react_1.default.useState(0), 2), manualCount = _b[0], setManualCount = _b[1];
    var remotelyModeratedLine = {
        name: resources.inboxName.remotelyModerated,
        tooltip: resources.inboxName.remotelyModeratedTooltip,
        number: remotelyModeratedCount,
        percentage: totalReceivedCount > 0 ? remotelyModeratedCount / totalReceivedCount : 0,
    };
    var implioModerated = totalReceivedCount - remotelyModeratedCount;
    var implioModeratedLine = {
        name: resources.inboxName.implioModerated,
        tooltip: resources.inboxName.implioModeratedTooltip,
        number: implioModerated,
        percentage: totalReceivedCount > 0 ? implioModerated / totalReceivedCount : 0,
    };
    var mapManualCardData = function (queues) {
        var queuesWithOldestDate = queues.filter(function (i) { return i.oldest; });
        var oldestQueueItem;
        if (queuesWithOldestDate.length > 0) {
            oldestQueueItem = queuesWithOldestDate.reduce(function (prev, curr) {
                return prev.oldest && curr.oldest && Date.parse(prev.oldest) < Date.parse(curr.oldest) ? prev : curr;
            });
        }
        // eslint-disable-next-line no-return-assign,no-param-reassign
        var manualCount = queues.reduce(function (prev, curr) { return (prev += curr.count ? curr.count : 0); }, 0);
        setManualCount(manualCount);
        var line1Data = {
            name: getJobAge(oldestQueueItem === null || oldestQueueItem === void 0 ? void 0 : oldestQueueItem.oldest) && resources.oldestJobAgeTitle,
            number: getJobAge(oldestQueueItem === null || oldestQueueItem === void 0 ? void 0 : oldestQueueItem.oldest),
        };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        setManualModerationLine(line1Data);
    };
    var getJobAge = function (oldestTime) {
        if (!oldestTime)
            return '';
        var oldestDate = new Date(oldestTime);
        return (0, date_fns_1.formatDistanceStrict)(oldestDate, new Date());
    };
    (0, react_1.useEffect)(function () {
        if (queues && queues.length > 0) {
            mapManualCardData(queues);
        }
    }, [queues]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "stat-cards-container" },
            react_1.default.createElement(SummaryCard_1.default, { name: "total-received", cardTitle: resources.inboxName.total, mainNumber: totalReceivedCount, line1: implioModeratedLine, line2: remotelyModeratedLine }),
            queues && (react_1.default.createElement(SummaryCard_1.default, { name: "now-in-manual", cardTitle: resources.nowInManual, mainNumber: manualCount, line1: manualModerationLine })))));
}
exports.default = ManualCardGroup;
